import { graphql } from '../../graphql/generated';

export const DOCTORS_QUERY = graphql(`
  query DoctorsForAssignment {
    doctors {
      id
      name
      meAddress
      firstName
      lastName
      postTitle
      preTitle
      salutation
      disabled
    }
  }
`);

export const USERS_QUERY = graphql(`
  query Users($page: Int!, $pageSize: Int!, $doctorId: String, $search: String) {
    users(page: $page, pageSize: $pageSize, doctorId: $doctorId, search: $search) {
      total
      limit
      start
      length
      items {
        id
        username
        email
        firstName
        lastName
        disabled
        roles
        userAssignment {
          id
          primaryDoctor {
            id
            name
            salutation
            preTitle
            firstName
            lastName
            postTitle
            disabled
          }
          additionalDoctors {
            id
            name
            salutation
            preTitle
            firstName
            lastName
            postTitle
            disabled
          }
        }
      }
    }
  }
`);

export const DELETE_USER_ASSIGNMENT_MUTATION = graphql(`
  mutation DeleteUserAssignment($id: ID!) {
    deleteUserAssignment(id: $id)
  }
`);
